var n;
function e(t) {
  n = t;
}
function r() {
  return n;
}
export {
  r as getI18n,
  e as setI18n
};
